import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private userService: UserService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.userService.userInfo && this.userService.userLoggedIn) {

      // Gli utenti GUEST possono accedere solo alle routes delle responses
      const ALLOWED_ROUTES_TO_GUEST_USER  = [
        'responses',
        'guest',
        'profile',
        'contests/propose',
        '/organization/all',
        '/organization/' + this.userService.userDetails.current_organization_id + '/user/' + this.userService.getCurrentOrganizationUser()?.id,
        // Onboarding clinico (DBEK-391 epic): i clinici invitati al survey restano GUEST
        // a livello di organizzazione (per design - non devono ottenere visibilità
        // sull'intera organizzazione), quindi questa route va esplicitamente in whitelist
        // o non sarebbero mai in grado di raggiungere il proprio wizard.
        'clinical-onboarding',
      ]
      if (
        !ALLOWED_ROUTES_TO_GUEST_USER.some((route) => state.url.includes(route)) &&
        this.userService.getCurrentOrganizationUser().role === "GUEST"
      ) {
        this.router.navigate(['/guest']);
        return false;
      }

      return true;
    }


    this.router.navigate(['/'], {queryParams: {returnUrl: state.url.split(";")[0]}});
    return false;
  }

}
